// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"40147882","815":"27165269"}[chunkId] + ".chunk.js";
};